import * as types from './mutation-types'
import axios from 'axios'

export const ActionDefinirDadosConfiguracoes = async ({ commit }, parametrosRequisicao) => {
  const resposta = await axios.get('/configuracoes')
  commit(types.SET_DADOS_AGENDA, resposta.data.retorno.dados.agenda)
}

export const ActionHabilitarOuDesabilitarCaldav = ({ commit }) => {
  commit(types.SET_HABILITAR_OU_DESABILITAR_CALDAV)
}

export const ActionResetarDadosFormularioAgenda = ({ commit }) => {
  commit(types.SET_DADOS_FORMULARIO_AGENDA, {
    f_caldav_password: null,
    enableCaldavSync: false,
    enableIcalSync: false,
    enableAutomatedInviteConfirmation: false,
    enableAutomatedInviteAcceptance: false,
    enableViewCustomerBirthdays: false,
    enableViewEventAppointments: false,
    enableViewEventHearings: false,
    enableViewEventActivities: false,
    enableViewSharingPersonal: false,
    enableViewSharingBirthdays: false,
    enableViewSharingActivities: false,
    enableViewSharingAppointments: false,
    enableViewSharingHearings: false
  })
}
export const ActionResetarDadosAgenda = ({ commit }) => {
  commit(types.SET_RESETAR_DADOS_AGENDA,
    {
      caldavData: null,
      caldavSyncAllowed: false,
      icalSyncAllowed: false,
      formulario: {
        f_caldav_password: null,
        enableCaldavSync: false,
        enableIcalSync: false,
        enableAutomatedInviteConfirmation: false,
        enableAutomatedInviteAcceptance: false,
        enableViewCustomerBirthdays: false,
        enableViewEventAppointments: false,
        enableViewEventHearings: false,
        enableViewEventActivities: false,
        enableViewSharingPersonal: false,
        enableViewSharingBirthdays: false,
        enableViewSharingActivities: false,
        enableViewSharingAppointments: false,
        enableViewSharingHearings: false
      }
    }
  )
}

export const ActionDefinirDadosRetornoCadastro = ({ commit }, dadosRetornoCadastro) => {
  commit(types.SET_DADOS_RETORNO_CADASTRO, {
    sucesso: dadosRetornoCadastro.sucesso,
    mensagem: dadosRetornoCadastro.mensagem,
    listaDeErros: dadosRetornoCadastro.listaDeErros
  })
}

export const ActionResetarDadosRetornoCadastro = ({ commit }) => {
  commit(types.SET_DADOS_RETORNO_CADASTRO, {
    sucesso: false,
    mensagem: '',
    listaDeErros: {}
  })
}
